/**
 * `GET /api/v1/branding/{tenantSlug}/logo` (00 `ISO-16`, `ISO-16b`, `ISO-28b.c`; `AM-174`): the one
 * unauthenticated route of this product that touches tenant data. It always answers `200` - the
 * tenant's own logo when it has one, the neutral default otherwise - so this helper never has to
 * decide whether to render an `<img>`; the caller decides that from `hasLogo` and passes it a
 * `logoVersion` purely to bust the browser's cache when the logo changes under the same slug.
 */
export function tenantLogoUrl(tenantSlug: string, logoVersion?: string | null): string {
  const path = `/api/v1/branding/${encodeURIComponent(tenantSlug)}/logo`;
  return logoVersion === undefined || logoVersion === null
    ? path
    : `${path}?v=${encodeURIComponent(logoVersion)}`;
}
